import { openMessageSourceDialog } from '../components/ViewMessageSourceDialog';
import { DEFAULT_ACTION_SOURCE } from '../utils/constants';
import getActionSource from '../utils/getActionSource';
import { logUsage } from 'owa-analytics';
import { ActionSource } from 'owa-mail-store';
import { ClientItem } from 'owa-mail-store';
import { SurfaceActionItem } from 'owa-surface-actions';
import * as React from 'react';

export default function onViewMessageSource(clientItem: ClientItem, actionSource: ActionSource) {
    return (
        event: React.KeyboardEvent<HTMLElement> | React.MouseEvent<HTMLElement>,
        item?: SurfaceActionItem
    ) => {
        event.stopPropagation();

        logUsage(
            'ViewMessageSource',
            {
                subActionSource: getActionSource(item, actionSource),
            },
            {
                actionSource: DEFAULT_ACTION_SOURCE,
            }
        );

        openMessageSourceDialog(clientItem);
    };
}
